import { useState } from 'react'
import { Paper, Button, Box, Typography, Stack, Tabs, Tab } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

import { useParams } from 'react-router-dom';
import CatererPerLegGrid from './CatererPerLegGrid';
import ExcludedLegsGrid from './ExcludedLegsGrid';

function CatererPerLeg() {
    const { t } = useTranslation();
    const { clientCode } = useParams();
    const [tabIndex, setTabIndex] = useState(0);
    const [showCreateCatererPerLegDialog, setShowCreateCatererPerLegDialog] = useState(false);
    const [showCreateExcludedLegDialog, setShowCreateExcludedLegDialog] = useState(false);
    

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        
        setTabIndex(newValue);
    };

    
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                {/* Header with Tabs */}
                <Paper sx={{ p: 2, paddingBottom: 0, display: 'flex', flexWrap: 'wrap', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }} elevation={3}>
                    <Box sx={{flexGrow: 1, mr: { xs: 0, md: 2 }, mb: { xs: 2, md: 0 } }}>
                        <Typography variant="subtitle1" component="h2" sx={{ textTransform: 'uppercase' }}>
                        {t('Caterer per Leg')}
                        </Typography>
                        <Stack direction='row' spacing={2} style={{float:'right', marginTop:-20}}>
                            <Button variant="contained" onClick={() => tabIndex === 0 ? setShowCreateCatererPerLegDialog(true) : setShowCreateExcludedLegDialog(true) }>Create</Button>
                        </Stack>
                    </Box>
                    <div style={{flexBasis:'100%', flexGrow:1}}>
                        
                    </div>
                    <Tabs value={tabIndex} onChange={handleTabChange}>
                        <Tab label="Caterer" onClick={(e) => handleTabChange(e, 0)}/>
                        <Tab label="Excluded Legs" onClick={(e) => handleTabChange(e, 1)}/>
                    </Tabs>
                </Paper>
            </Grid>
            { clientCode !== undefined && tabIndex === 0 ?
                (<CatererPerLegGrid clientCode={clientCode} showCreateDialog={showCreateCatererPerLegDialog} cancelAction={() => setShowCreateCatererPerLegDialog(false)} />)
                : (<></>)
            }

            { clientCode !== undefined && tabIndex === 1 ?
                (<ExcludedLegsGrid clientCode={clientCode} showCreateDialog={showCreateExcludedLegDialog} cancelAction={() => setShowCreateExcludedLegDialog(false)} />)
                : (<></>)
            }
        </Grid>
    );
}

export default CatererPerLeg;